import React from "react";
import HeaderSectionReusableComponent from "../../component/ReusablaeComponent/HeaderSectionReusableComponent";
import Image_ContentReusableComponent from "../../component/ReusablaeComponent/Image_ContentReusableComponent";
import HeadingParagraphSection from "../../component/ReusablaeComponent/HeadingParagraphSection";
import RoboticHandsImage from '../../../Assets/automotive1.png';
import SupplyChainImage from '../../../Assets/automotive2.png';
import AIToolsImage from '../../../Assets/automotive3.png';
import DigitalImage from '../../../Assets/automotive4.png'
import { Helmet } from 'react-helmet';


const Automative = () => {
  return (
    <div>
      <Helmet>
        <title>PT KCS | Automotive Industry ERP & IT Solutions Indonesia – Jakarta, Surabaya</title>
        <meta
          name="description"
          content="PT KCS delivers specialized ERP and digital solutions for Indonesia's automotive industry. Optimize production planning, supply chain, quality control, OEM/dealer management across Jakarta, Surabaya, and Bandung with Infor LN, M3, and Syteline."
        />
        <meta
          name="keywords"
          content="PT KCS, PT KCS Indonesia, automotive ERP Jakarta, automotive IT solutions Indonesia, otomotif ERP Indonesia, industri otomotif solusi digital, manufaktur otomotif Indonesia, automotive supply chain management, automotive quality control ERP, automotive production planning software, car manufacturing ERP Indonesia, vehicle assembly ERP, spare parts inventory management Indonesia, OEM supplier ERP system, automotive after-sales management, dealer management system Indonesia, Infor LN automotive, Infor M3 automotive, SAP automotive Indonesia, ERP untuk industri otomotif, konsultan ERP otomotif Jakarta, automotive workforce management, automotive compliance software, ERP Surabaya manufaktur, ERP Bandung otomotif, connected factory automotive Indonesia, automotive digital transformation, Industry 4.0 otomotif, JIT inventory management, Tier 1 supplier ERP, automotive MES Indonesia, procurement sistem otomotif, automotive performance analytics, machine maintenance ERP, production scheduling software Indonesia, quality management automotive, automotive costing ERP"
        />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>

      <HeaderSectionReusableComponent
        mainHeading={"Simplify Automotive Operations with Smarter Systems"}
        paragragh={
          <>
           At PTKCS, we streamline the complex operations of automotive companies—from sourcing and assembly to inventory and after-sales service. Our ERP solutions connect every department into a single digital ecosystem, enabling real-time tracking of production, resources, and job orders. With centralized data and connected workflows, manufacturers and suppliers can eliminate silos, reduce manual tasks, and maintain smooth, efficient operations aligned with their business goals.</>
        }
        imgScr={RoboticHandsImage}
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        heading="Gain Full Visibility Across Your Automotive Supply Chain"
        paragraph={
          <>
            Lack of visibility is a major challenge in the automotive supply chain. PTKCS addresses this with ERP solutions that deliver a real-time, 360° view of materials, orders, and suppliers. From raw material sourcing to vehicle delivery, every stage is transparent. With features like Just-in-Time (JIT) inventory, real-time stock tracking, multi-location warehouse management, and supplier performance monitoring, our system helps you make faster decisions, reduce delays, and stay responsive to market changes.
          </>
        }
        imgsrc={SupplyChainImage}
      />
      <HeadingParagraphSection
        heading={"Scale Your Business Without Scaling Complexity"}
        paragraph={
          <>
            Growth in the automotive industry often comes with complexity—new product lines, expanded operations, additional locations, and increased customer demands. PTKCS ensures your technology doesn’t hold you back. We design scalable ERP systems that evolve with your business, so you can expand your operations without reinventing the wheel.
            Whether you're a startup in aftermarket parts or an established Tier 1 supplier, our solutions are built to grow with you. You can easily add new users, processes, locations, or business units—without losing control or data integrity. We make sure your back-end systems are as agile as your business strategy.
          </>
        }
      />

      <Image_ContentReusableComponent
        bgColor="#fff"
        reverse={false}
        heading="Automate the Routine, Focus on What Matters"
        paragraph={
          <>
            Manual processes slow operations, increase errors, and waste time. PTKCS automates repetitive tasks—letting your team focus on high-value work like innovation and customer service. Our smart automation and AI-powered analytics streamline purchase orders, work orders, billing, compliance, and customer communication. Automated alerts, production reports, and real-time dashboards provide instant visibility into key performance metrics, helping decision-makers act faster and smarter.
          </>
        }
        imgsrc={AIToolsImage}
      />
      <Image_ContentReusableComponent
      
        heading="Accelerate Your Digital Transformation Journey"
        paragraph={
          <>
            The future of automotive is digital—connected factories, smart vehicles, electric mobility, and global collaboration. PTKCS drives your digital transformation by modernizing operations and preparing your business for emerging technologies. Our ERP solutions support cloud access, AI insights, IoT integration, and real-time collaboration, helping you innovate faster, streamline processes, and stay ahead of the competition.
          </>
        }
        imgsrc={DigitalImage}
      />
    </div>
  );
};

export default Automative;
